// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"21787fa1","220":"0fc60364","748":"6b55b210","815":"25bd35ad","837":"21787fa1"}[chunkId] + ".css";
};